'use strict';

import register from './core';
import '../functions/jquery-global.js';
import waypoints from 'waypoints/lib/jquery.waypoints';
import infinite from 'waypoints/lib/shortcuts/infinite';

register('filter', function (element) {
  var $filter = $(element),
    $form = $('#filter-form'),
    $result = $('#list'),
    timeout = null,
    url = null,
    infinite = null,
    initInfinite = function () {
      infinite = new Waypoint.Infinite({
        element: $('.list__list')[0],
        items: '.list__item',
        onBeforePageLoad: () => loadMore(),
        onAfterPageLoad: function () { }
      });
    },
    filter = {
      doFiltering: function (query) {

        var newUrl = window.location.pathname;
        newUrl += typeof query === 'undefined' ? '?' + $form.serialize() : query;
        console.log('doFiltering', newUrl);
        if (url !== newUrl) {
          url = newUrl;

          $('#main').addClass('fade-content--active');
          $form.find('fieldset').prop('disabled', true);

          $('#list').load(url + ' ' + '#list-container', function (data) {

            if (infinite) infinite.destroy();

            $('#main').removeClass('fade-content--active');
            $form.find('fieldset').prop('disabled', false);

            if (history.pushState) {
              window.history.pushState(null, '', url);
            }
            initInfinite();
          });
        }
        return this;
      },
      onFiltering: function () {

      }

    },
    loadMore = function () {
      var nextLink = $('#filterMoreResults').attr('href');
      console.log('loading more');
      $('#filterMoreResults').attr('href' + nextLink + '&ajax=true');
    };

  initInfinite();

  $form.on('change', function (e) {
    filter.doFiltering();
  });
});
